import { ApiConfig } from '../../Config.js';
import axios from 'axios';

var GetStatisticsCtrl = function (fn, er, state, token, ids) {

	var config = {
		headers: {
			'Authorization': 'Bearer ' + token,
			'Content-Type': 'application/json',
			'MT_SESSION_ID': ids
		},
	};
	var data = {
		orderBy: "+sequence",
		period: state.typePeriod,
		codPos: state.codepv
	};

	axios
		.post(ApiConfig.url.GET_STATISTICS, data, config)
		.then(function (result) {
			fn(result.data.statistics)
		})
		.catch(function (error) {
			er(error !== undefined && error.response !== undefined && error.response.status !== undefined ? error.response.status : 500)
		});
}

export { GetStatisticsCtrl };